import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  StaffApplicationFilters,
  StaffApplicationLight
} from '../../lib/types/models/staff-application/staff-application'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPcrStaffApplications(
  input: PaginationRequest<StaffApplicationFilters>,
  pcrId: number
) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.pcr.getStaffApplications.url, { id: pcrId }),
        input
      )
    )
    .get<PaginationResponse<StaffApplicationLight>>()
}
